import { DialogProps } from "models/propTypes/dialogPropTypes";
import { DialogEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { LocalizationHelperInstance } from "utils/helpers";
import ScheduleChangeForm from "./scheduleChangeForm";

interface ScheduleChangeDialogResult {
  startDate: Date;
}

function useScheduleChangeDialog() {
  const getDialog = (
    onSubmit: (result: ScheduleChangeDialogResult) => void,
    onCancel: () => void,
    hasExistingSchedule: boolean = false,
    defaultDate?: Date,
    minDate?: Date
  ): DialogProps => {
    return {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Settings.ScheduleChangesTitle),
      titleIcon: IconDefinitionConstants.WCalendar,
      dialogType: DialogEnums.DialogType.Content,
      children: <ScheduleChangeForm hasExistingSchedule={hasExistingSchedule} defaultDate={defaultDate} minDate={minDate} />,
      maxWidth: "sm",
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Save),
        },
      ],
      onSubmit: (values: ScheduleChangeDialogResult) => {
        onSubmit(values);
      },
      onClose: () => {
        onCancel();
      },
    };
  };

  return { getDialog };
}

export default useScheduleChangeDialog;

